import theme from './theme';

export { theme };
export { colors } from './colors';
export { constants } from './constants';

export default theme;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJ0aGVtZSIsImNvbG9ycyIsImNvbnN0YW50cyJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBT0EsS0FBUCxNQUFrQixTQUFsQjs7QUFFQSxTQUFTQSxLQUFUO0FBQ0EsU0FBU0MsTUFBVCxRQUF1QixVQUF2QjtBQUNBLFNBQVNDLFNBQVQsUUFBMEIsYUFBMUI7O0FBRUEsZUFBZUYsS0FBZiIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0aGVtZSBmcm9tICcuL3RoZW1lJztcblxuZXhwb3J0IHsgdGhlbWUgfTtcbmV4cG9ydCB7IGNvbG9ycyB9IGZyb20gJy4vY29sb3JzJztcbmV4cG9ydCB7IGNvbnN0YW50cyB9IGZyb20gJy4vY29uc3RhbnRzJ1xuXG5leHBvcnQgZGVmYXVsdCB0aGVtZTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../node_modules/@opuscapita/oc-cm-theme/lib/es/index.js
// module id = null
// module chunks = 